// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DatabaseTwoToneSvg from "@fishx/icons-svg/es/asn/DatabaseTwoTone";
import FishxIcon from '../components/FishxIcon';

var DatabaseTwoTone = function DatabaseTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseTwoToneSvg
  }));
};

DatabaseTwoTone.displayName = 'DatabaseTwoTone';
export default React.forwardRef(DatabaseTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DatabaseTwoTone.js
// module id = 2377
// module chunks = 0